import { bind } from "@react-rxjs/core"
import {
  catchError,
  EMPTY,
  map,
  mergeMap,
  scan,
  switchMap,
  take,
  timer,
} from "rxjs"

import { tradingGatewayServices$ } from "@/services/tradingGateway"
import { withConnection } from "@/services/withConnection"
import { log } from "@/utils"

let count = 0
const [useLatency, latency$] = bind(
  timer(0, 1000).pipe(
    withConnection(),
    switchMap(() => {
      const start = new Date().getTime()
      return tradingGatewayServices$.pipe(
        take(1),
        mergeMap((services) => services.echoService.echo({ payload: count++ })),
        map(() => {
          const stop = new Date().getTime()
          return stop - start
        }),
        catchError((e) => {
          log.error("Error pinging echo service", e)
          return EMPTY
        }),
      )
    }),
  ),
  0,
)

const MAX_SECONDS = 30
const [_hook, latencyHistory$] = bind(
  latency$.pipe(
    scan(
      (acc, value) => {
        acc.push(value)
        if (acc.length > MAX_SECONDS) {
          acc.splice(0, 1)
        }
        return [...acc]
      },
      [0],
    ),
  ),
)

export { latencyHistory$, useLatency }
